/**
 * useCreatorTokens — Fetches all tokens created by the authenticated wallet.
 *
 * Requires wallet connection and access token.
 * Returns token list with indexer stats (nullable per token).
 *
 * Story 6.2 — Task 2.2
 */

import { useQuery } from "@tanstack/react-query";
import { creatorApi } from "../../lib/api";
import { useWallet } from "../use-wallet";
import { creatorKeys } from "./query-keys";

export function useCreatorTokens() {
	const { address, getAccessToken } = useWallet();

	return useQuery({
		queryKey: creatorKeys.tokens(address),
		queryFn: async () => {
			const accessToken = await getAccessToken();
			if (!accessToken) {
				// eslint-disable-next-line no-restricted-syntax -- TanStack Query requires thrown errors
				throw new Error("No access token available");
			}
			const response = await creatorApi.getTokens(accessToken, address);
			return response.data;
		},
		enabled: !!address,
		staleTime: 30_000,
	});
}
